<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="落地页id" prop="pageId">
          <el-input v-model="dataForm.pageId" placeholder="落地页id"></el-input>
      </el-form-item>
          <el-form-item label="ip" prop="ip">
          <el-input v-model="dataForm.ip" placeholder="ip"></el-input>
      </el-form-item>
          <el-form-item label="来源 1.手机  2.页面" prop="channel">
          <el-input v-model="dataForm.channel" placeholder="来源 1.手机  2.页面"></el-input>
      </el-form-item>
          <el-form-item label="城市" prop="city">
          <el-input v-model="dataForm.city" placeholder="城市"></el-input>
      </el-form-item>
          <el-form-item label="手机号" prop="mobile">
          <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
      </el-form-item>
          <el-form-item label="验证码" prop="code">
          <el-input v-model="dataForm.code" placeholder="验证码"></el-input>
      </el-form-item>
          <el-form-item label="状态（开1、关0）" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>
      </el-form-item>
          <el-form-item label="创建人" prop="createdBy">
          <el-input v-model="dataForm.createdBy" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="修改人" prop="updatedBy">
          <el-input v-model="dataForm.updatedBy" placeholder="修改人"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="修改时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="修改时间"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        pageId: '',
        ip: '',
        channel: '',
        city: '',
        mobile: '',
        code: '',
        status: '',
        createdBy: '',
        updatedBy: '',
        createTime: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        pageId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ip: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channel: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updatedBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/rdsmslog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/rdsmslog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
